<script>
	import TextInput from "../TextInput.svelte";
	import FormRow from "../FormRow.svelte";
	import FormColumn from "../FormColumn.svelte";
	import TextButton from "../buttons/TextButton.svelte";
	import Country from "./Country.svelte";

	import LoqateAddressAutoComplete from "./LoqateAddressAutoComplete.svelte";
	import ManualAddress from "./ManualAddress.svelte";

	export let address = {};
	export let disabled = false;
	export let required = false;
	export let index = 1;

	let showManualEntry = false;

	let previousCountryCode = address.CountryCode;

	address.Country = address.Country || "Australia";
	address.CountryCode = address.CountryCode || "au";

	const handleCountryChange = () => {
		if (previousCountryCode === address.CountryCode) return;

		// When country changes, reset address fields to prevent invalid address data.
		// Preserve country, countryCode, and manualEntry mode.
		const { Country, CountryCode, ManualEntry } = address;
		address = { Country, CountryCode, ManualEntry };

		previousCountryCode = address.CountryCode;
	};

	const toggleManualEntry = () => {
		address.ManualEntry = !address.ManualEntry;
		address = { ...address };
	};
</script>

{#if !disabled}
	<FormRow>
		<FormColumn cols="4">
			<Country
				{disabled}
				label="Country"
				bind:country={address.Country}
				bind:countryCode={address.CountryCode}
				{required}
				id="country{index}"
				on:change={handleCountryChange} />
		</FormColumn>

		<FormColumn cols="8">
			<div class:hidden={address.ManualEntry}>
				<LoqateAddressAutoComplete {required} {disabled} bind:address {index} bind:showManualEntry />
			</div>
		</FormColumn>
	</FormRow>

	{#if address.ManualEntry}
		<ManualAddress {required} {disabled} bind:address />
	{/if}

	{#if showManualEntry}
		<TextButton on:click={toggleManualEntry}>
			{address.ManualEntry ? "Search for address" : "Enter address manually"}
		</TextButton>
	{/if}
{:else}
	<FormRow>
		<FormColumn>
			<TextInput disabled {required} value={address.FormattedAddress} label="Address" />
		</FormColumn>
	</FormRow>
{/if}

<style>
	.hidden {
		display: none;
	}
</style>
